<template>
    <v-container fluid class="main-body">
        <r-header></r-header>
        <HeaderPanel></HeaderPanel>
        <v-skeleton-loader
                v-if="!isVisible"
                ref="rosconForm"
                type="article"
                class="mx-auto"
        ></v-skeleton-loader>
        <v-form id="form" ref="rosconForm" v-if="isVisible" lazy-validation v-model="isValid">
            <v-container style="padding: 0 2rem;">
                <!-- NOMBRE, APELLIDOS, FNAC -->
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                                label="Nombre"
                                prepend-icon="face"
                                v-model.trim="persona.nombre"
                                required
                                :rules="rules.nombre"
                        >
                            <template v-slot:label>
                                Nombre<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                prepend-icon="face"
                                v-model.trim="persona.apellidos"
                                required
                                :rules="rules.apellidos"

                        >
                            <template v-slot:label>
                                Apellidos<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <datePicker
                                @change="cambia"
                                required
                                v-model.trim="persona.fnac"
                                :current="currentDate"
                                max="2005-01-29"
                                v-if="viewDate"
                        >
                            <template v-slot:append-outer>
                                <v-icon small color="primary">*</v-icon>
                            </template>
                        </datePicker>
                    </v-col>
                </v-row>

                <!-- DNI, LOCALIDAD, GENERO -->
                <v-row>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                prepend-icon="fingerprint"
                                v-model.trim="persona.dni"
                                required
                                :rules="rules.dni"
                                maxlength="9"
                        >
                            <template v-slot:label>
                                DNI<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                prepend-icon="location_city"
                                v-model.trim="persona.localidad"
                                :rules="rules.localidad"
                        >
                            <template v-slot:label>
                                Localidad de residencia<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-radio-group row label="Genero"
                                       v-model="persona.sexo"
                                       required
                                       :rules="rules.sexo"
                        >
                            <v-radio label="Hombre" value="V"

                            ></v-radio>
                            <v-radio label="Mujer" value="F"


                            ></v-radio>
                            <template v-slot:label>
                                Genero<sup>
                                *
                            </sup>
                            </template>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <!-- EMAIL, TFNO, SOCIO -->
                <v-row>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                prepend-icon="email"
                                v-model.trim="persona.email"
                                :rules="rules.email"
                                required
                        >
                            <template v-slot:label>
                                Correo electrónico<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                label="Teléfono de contacto"
                                prepend-icon="phone"
                                v-model.trim="persona.tlfno"
                                required
                                :rules="rules.tlfno"
                                maxlength="9"

                        >
                            <template v-slot:label>
                                Teléfono de contacto<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-radio-group row label="¿Eres socio de Os Andarines de Aragón?"
                                       v-model.trim="persona.socio"
                                       required
                                       :rules="rules.socio"
                        >
                            <template v-slot:label>
                                <span style="font-size: 1.05rem;">¿Eres socio de Os Andarines de Aragón?</span>
                            </template>
                            <v-radio label="SI" value="SI"

                            ></v-radio>
                            <v-radio label="NO" value="NO"

                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <!-- DATOS DEL TUTOR -->
                <v-banner v-model="isMenor" transition="slide-y-transition"
                          elevation="4" color="blue lighten-1">
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-center">Datos del padre, madre o tutor</h2><br>
                            <p>Por ser menor de 18 años se debe facilitar los datos de una persona mayor de edad que actuará
                                como tutor y se responsabilizará de que el menor esté capacitado para participar en la
                                carrera.</p>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" >
                            <v-text-field
                                    prepend-icon="face"
                                    v-model.trim="persona.nombre_tutor"
                                    :rules="rules.nombre_tutor"
                                    :required="isMenor"
                            >
                                <template v-slot:label>
                                    Nombre y apellidos del tutor<sup>
                                    *
                                </sup>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" >
                            <v-text-field
                                    label="DNI del tutor"
                                    prepend-icon="fingerprint"
                                    v-model.trim="persona.dni_tutor"
                                    :rules="rules.dni_tutor"
                                    :required="isMenor"
                                    maxlength="9"
                            >
                                <template v-slot:label>
                                    DNI del tutor<sup>
                                    *
                                </sup>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" >
                            <v-text-field
                                    label="Teléfono de contacto"
                                    prepend-icon="phone"
                                    v-model.trim="persona.tlfno_tutor"
                                    :rules="rules.tlfno_tutor"
                                    :required="isMenor"
                                    maxlength="9"
                            >
                                <template v-slot:label>
                                    Teléfono de contacto<sup>
                                    *
                                </sup>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-banner>

                <!-- CATEGORIA, MARCA, APODO -->
                <v-row>
                    <v-col cols="12" sm="6" md="4" >
                        <v-select
                                :items="categorias"
                                prepend-icon="group_work"
                                label="Categoría"
                                v-model.trim="persona.idCategoria"
                                item-text="nombre"
                                item-value="id"
                        >
                            <template v-slot:append-outer>
                                <v-dialog v-model="infoCategoria" persistent max-width="600px">
                                    <template v-slot:activator="{ on }">
                                        <v-icon small color="primary" v-on="on">info</v-icon>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">Información sobre las categorías</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-text>
                                                            La categoría se asigna automáticamente en función de la fecha de nacimiento. Si por el
                                                            motivo que fuese deseases correr en otra categoría, por ejemplo en la Absoluta, debes
                                                            informarlo en el apartado de ‘Observaciones’ de más abajo.
                                                        </v-text>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="infoCategoria = false">Cerrar</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-select
                                :items="marcas"
                                prepend-icon="watch_later"
                                v-model="persona.marca"
                                required
                                :rules="rules.marca"
                        >
                            <template v-slot:label>
                                Marca prevista<sup>
                                *
                            </sup>
                            </template>
                            <template v-slot:append-outer>
                                <v-dialog v-model="infoMarca" persistent max-width="600px">
                                    <template v-slot:activator="{ on }">
                                        <v-icon small color="primary" v-on="on">info</v-icon>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">Información de marca prevista</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <p class="text-justify">
                                                            Por favor, por respeto a los demás corredores, se honesto con la
                                                            marca que puedes hacer.
                                                        </p>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="infoMarca = false">Cerrar</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                                label="Apodo"
                                prepend-icon="label"
                                v-model="persona.apodo"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- FEDERADO, LICENCIA, CLUB -->
                <v-row>
                    <v-col cols="12" sm="6" md="4" >
                        <v-radio-group row
                                       v-model.trim="persona.federado"
                                       required
                                       :rules="rules.federado"

                        >
                            <template v-slot:label>
                                Federado en atletismo<sup>
                                *
                            </sup>
                            </template>
                            <v-radio label="SI" value="SI"

                            ></v-radio>
                            <v-radio label="NO" value="NO"

                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                label="Nº de Licencia Atletismo"
                                prepend-icon="credit_card"
                                placeholder="Obligatorio para atletas federados"
                                v-model="persona.licencia"
                                required
                                :rules="rules.licencia"

                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                                label="Club"
                                prepend-icon="group"
                                v-model="persona.club"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- CAMISETA, TALLA, DUCHAS -->
                <v-row>
                    <v-col cols="12" sm="6" md="4" >
                        <v-radio-group row
                                       v-model="persona.camiseta"
                                       required
                                       :rules="rules.camiseta"

                        >
                            <template v-slot:label>
                                Quiero camiseta<sup>
                                *
                            </sup>
                            </template>
                            <v-radio label="SI" value="SI"

                            ></v-radio>
                            <v-radio label="NO" value="NO" :disabled="persona.socio === 'SI'" ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-select
                                :items="tallas"
                                prepend-icon="list"
                                label="Talla de la camiseta"
                                required
                                :rules="rules.talla"
                                v-model="persona.talla"
                                @blur="rules.talla"

                        >
                            <template v-slot:append-outer>
                                <v-dialog v-model="infoTallas" persistent max-width="600px">
                                    <template v-slot:activator="{ on }">
                                        <v-icon small color="primary" v-on="on">info</v-icon>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">Tallas según disponibilidad</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-img src="@/assets/tallas_camisetas.jpg"
                                                               lazy-src="@/assets/tallas_camisetas.jpg"
                                                        ></v-img>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="infoTallas = false">Cerrar</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-radio-group row
                                       v-model.trim="persona.ducha"
                                       required
                                       :rules="rules.ducha"

                        >
                            <template v-slot:label>
                                Uso de servicio de DUCHAS en CDM Siglo XXI<sup>
                                *
                            </sup>
                            </template>
                            <v-radio label="SI" value="SI"


                            ></v-radio>
                            <v-radio label="NO" value="NO"


                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <!-- TIENDA, ESTADO, DORSAL -->
                <v-row>
                    <v-col cols="12" sm="6" md="4" >
                        <v-select
                                :items="tiendas"
                                prepend-icon="storefront"
                                label="Tienda"
                                v-model.trim="persona.idTienda"
                                item-text="nombre"
                                item-value="id"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-select
                                :items="estados"
                                prepend-icon="sort"
                                label="Estado de la inscripción"
                                v-model.trim="persona.idEstado"
                                item-text="nombre"
                                item-value="id"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                                label="Dorsal"
                                prepend-icon="money"
                                v-model="persona.dorsal"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- OBSERVACIONES -->
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                                name="observaciones"
                                label="Observaciones"
                                v-model="persona.observaciones"
                        ></v-textarea>
                    </v-col>
                </v-row>

                <!-- BOTONES -->
                <v-row>
                    <v-col cols="6">
                        <v-btn block large color="success darken-3" @click="actualizar">Guardar cambios</v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn block large color="info lighten-1" :to="{ name:'panel' }">
                            Volver al listado
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-dialog v-model="resultado" persistent max-width="600px">
            <template v-slot:activator="{ on }">

            </template>
            <v-card>
                <v-card-title>
                    <span class="headline myModal">Actualización de datos realizada</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <h4>Los datos para este corredor se han actualizado</h4>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text to="/panel">Volver al listado</v-btn>
                    <v-btn color="blue darken-1" text @click="resultado = false">Seguir editando</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import DatepickerComponent from "@/components/shared/DatepickerComponent"
    import {cat, tallas, tiendas} from '@/config'
    import moment from "moment";
    import HeaderPanel from "../../components/shared/HeaderPanel";
    import {cookiesHelper} from "../../_helpers";
    import {panelService} from "../../_services/panel";
    import RHeader from "../../components/shared/HeaderComponent";
    export default {
        name: "Editar",
        props: ['carrera', 'id'],
        data() {
            return {
                isValid: true,
                isVisible: false,
                isMenor: false,
                infoTallas: false,
                infoMarca: false,
                infoCategoria: false,
                viewDate: true,
                resultado:false,
                currentDate: null,
                categorias: [],
                tallas: [],
                marcas: ['menos de 30\'', '30\' - 35\'', '35\' - 40\'', '40\' - 50\'', '50\' - 60\'', 'más de 60\''],
                tiendas: [],
                estados: [
                    { id:"5", nombre:'Inscrito' },
                    { id:"4", nombre:'Invitado' },
                ],
                diaCarrera: moment('2020-01-29'),
                persona: {
                    id:'',
                    dorsal:'',
                    nombre: '',
                    apellidos: '',
                    fnac: '',
                    dni: '',
                    localidad: '',
                    sexo: '',
                    email: '',
                    tlfno: '',
                    socio: '',
                    nombre_tutor: '',
                    dni_tutor: '',
                    tlfno_tutor: '',
                    idCategoria: '',
                    idTienda:'',
                    idEstado: '',
                    idCarrera: this.carrera,
                    precio_base: 0.0,
                    marca: '',
                    apodo: '',
                    federado: '',
                    licencia: '',
                    club: '',
                    camiseta: '',
                    talla: '',
                    ducha: '',
                    observaciones: '',
                    condiciones: false,
                    menor: 'NO'

                },
                token: '',
                rules:{
                    nombre: [
                        v => !!v || 'El nombre es necesario',
                        v => (v && v.length >= 3) || 'El nombre debe de tener 3 caracteres o mas.'
                    ],
                    apellidos:[
                        v => !!v || 'Los apellidos son necesarios',
                        v => (v && v.length >= 3) || 'Los apellidos deben de tener 3 caracteres o mas.'
                    ],
                    dni: [
                        v => !!v || 'El dni es necesario',
                        v =>/(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))/.test(v) ||
                            "El formato no es correcto (ej. 12345678A)"
                    ],
                    localidad: [
                        v => !!v || 'La localidad de residencia la necesitamos',
                        v => (v && v.length >= 3) || 'Debe de tener 3 caracteres o mas.'
                    ],
                    sexo: [
                        v => !!v || 'Es necesario para poder continuar',
                    ],
                    email: [
                        v => !!v || 'El email es necesario para poder contactar',
                        v => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(v)
                            || 'El email no tiene el formato correcto'
                    ],
                    tlfno: [
                        v => !!v || 'Es necesario por si necesitamos contactar',
                        v => /^\d+$/.test(v) || 'Solo se aceptan números',
                        v => (v && v.length == 9) || 'Debe de tener 9 numeros sin espacios.'
                    ],
                    nombre_tutor:[
                        v => { if ( this.isMenor ) return !!v || "Este campo es necesario."; else return !!v },
                        v => { if ( this.isMenor ) return (v && v.length > 10) || "Por lo menos 10 carácteres"; else return !!v },
                    ],
                    dni_tutor:[
                        v => { if ( this.isMenor ) return !!v || "Este campo es necesario."; else return !!v },
                        v => { if ( this.isMenor ) return /(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))/.test(v) ||
                            "El formato no es correcto (ej. 12345678A)"; else return !!v },
                    ],
                    tlfno_tutor:[
                        v => { if ( this.isMenor ) return !!v || "Este campo es necesario."; else return !!v },
                        v => { if ( this.isMenor ) return /^\d+$/.test(v) || "Solo se aceptan números"; else return !!v },
                        v => { if ( this.isMenor ) return (v && v.length == 9) || 'Debe de tener 9 numeros sin espacios.'; else return !!v },
                    ],
                    socio: [
                        v => !!v || 'Es necesario para poder continuar',
                    ],
                    marca: [
                        v => !!v || 'Es necesario para poder continuar',
                    ],
                    federado: [
                        v => !!v || 'Esta información necesitamos saberla',
                    ],
                    licencia: [
                        v => {  if(this.persona.federado === "SI") return !!v || 'Debe de ser un número de liciencia valido'; else return !!v}
                    ],
                    camiseta: [
                        v => !!v || 'Necesitamos saber si quieres o no camiseta',
                    ],
                    talla: [
                        //v => !!v || 'Necesitamos saber la talla de la camiseta' ,
                        v => {  if(this.persona.camiseta === "SI") return !!v || 'Necesitamos saber la talla de la camiseta'; else return !!v}
                    ],
                    ducha: [
                        v => !!v || 'Necesitamos saber si vas a usar el servicio de duchas o no',
                    ],
                    condiciones: [
                        v => !!v || 'Tienes que leer y aceptar las condiciones de la carrera',
                    ],
                    tienda: [
                        v => !!v || 'Esta información necesitamos saberla',
                    ],
                }
            }
        },
        created() {
            this.categorias = (this.carrera === 1) ? cat.diez : cat.siete
            this.tallas = tallas.diez
            this.tiendas = tiendas
            const c = cookiesHelper.getCookie('token')

            if (c=='') {
                this.$router.push({name:'login'})
            }else{
                this.token = c
                panelService.getInscrito(this.carrera, this.id, this.token).then( (rdo) => {
                    if (rdo.status === 200) {
                        Object.keys(this.persona).forEach( key => {
                            this.persona[key] = rdo.data[key]
                            //eslint-disable-next-line
                            //console.log(key, rdo.data[key])
                        } )
                        this.asignarFecha(this.persona.fnac)
                        this.persona.id = this.id
                        this.isVisible = true
                    } else {
                        cookiesHelper.setCookie('',0)
                        this.$router.push('login')
                    }
                } )
            }
        },
        methods: {
            cambia(data) {

                const today = moment()

                const edad = today.diff(data, 'years')
                const edadCarrera = this.diaCarrera.diff(data, 'years')


                if (edad < 18) this.isMenor = true; else this.isMenor = false;

                switch (true) {
                    case edadCarrera >= 15 && edadCarrera < 35:
                        this.persona.idCategoria = this.categorias[0].id;
                        break;
                    case edadCarrera >= 35 && edadCarrera < 45:
                        this.persona.idCategoria = this.categorias[1].id;
                        break;
                    case edadCarrera >= 45 && edadCarrera < 55:
                        this.persona.idCategoria = this.categorias[2].id;
                        break;
                    case edadCarrera >= 55:
                        this.persona.idCategoria = this.categorias[3].id;
                        break;
                    default:
                        break;
                }
                this.persona.fnac = data.format("YYYY-MM-DD")
                this.persona.menor = this.isMenor ? 'SI' : 'NO'
                this.persona.menor = this.isMenor ? 'SI' : 'NO'


            },

            asignarFecha(fecha) {
                const fnac = fecha.startsWith('0000') ? '' : fecha;
                this.currentDate = fnac
                this.viewDate = false
                setTimeout(() => {
                    this.viewDate = true;
                    this.cambia(moment(this.currentDate))
                }, 100)
            },

            actualizar() {
                panelService.updateInscrito(this.persona, this.token).then( res => {

                    if( res.data.success ) {
                        this.resultado = true
                    }
                })
            }
        },
        components: {
            RHeader,
            HeaderPanel,
            datePicker: DatepickerComponent
        }
    }
</script>

<style scoped lang="scss">
    @import "./../../_static/base";
    .contenido {
        width: 90%;
        margin: 0 auto;
    }
    #roscon{
        margin-top: 2rem;
    }
</style>